import { SET_POSTER_ON_TOP } from './../const';

export default (posterOnTop) => {
  return {
    type: SET_POSTER_ON_TOP,
    posterOnTop: posterOnTop
  }
};
